import init from 'share/packs/sessions'

init();
